var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "950" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("done")]),
                  _vm._v("\n       Aprobar incremento salarial\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                {
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", row: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [_vm._v("Gestión: ")]),
                          _vm._v(
                            " " + _vm._s(_vm.form.gestion) + "\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [_vm._v("Fecha de creación: ")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(_vm.form.fecha_creacion)
                                  .format("DD-MM-YYYY")
                              ) +
                              "\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _vm.form.fecha_aprobacion
                          ? _c("h3", { staticClass: "detalle" }, [
                              _c("strong", [_vm._v("Fecha de aprobación:")]),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.form.fecha_aprobacion)
                                      .format("DD-MM-YYYY")
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [_vm._v("Fecha de ejecución:")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(_vm.form.fecha_ejecucion)
                                  .format("DD-MM-YYYY")
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", { staticClass: "detalleSubtitulo" }, [
                    _c("strong", [_vm._v("Listado de incrementos salariales")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.incremento_salarial_detalles,
                              headers: _vm.headers_detalles
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(props.item.cargo) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.porcentaje))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              props.item.haber_basico_actual
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              props.item
                                                .haber_basico_incrementado
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", { staticClass: "detalleSubtitulo" }, [
                    _c("strong", [_vm._v("Seguimiento de registro")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.seguimientos,
                              headers: _vm.headers_seguimientos
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(props.item.fecha_registro) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.nombres))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(props.item.estado) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "rgb(66,13,242)", dark: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.aprobarIncremento()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("done")]), _vm._v(" aprobar\n        ")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("cancel")]),
                  _vm._v(" CANCELAR\n        ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70f9a9c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f9a9c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/incremento_salarial/dialogs/AprobarIncrementoSalarial.vue
// module id = null
// module chunks = 